import { Flex, Image, Tooltip, useMantineColorScheme } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

import { ChoosePlanModal } from "../PlanModals";

import lockerIcon from "@/assets/icons/locker.svg";

export const LabelContentLocker = () => {
  const { t } = useTranslation();
  const [showPlanModal, { open: openPlanModal, close: closePlanModal }] = useDisclosure();

  /* Theme */
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";
  const color = isDark ? "gray.4" : "dark";

  return (
    <>
      <Flex justify="center" gap="sm" align="center">
        <Tooltip label={t("plans.contentLocker.upgradeToAccess")} withArrow>
          <Image
            src={lockerIcon as unknown as string}
            width={22}
            height={22}
            c={color}
            alt={t("plans.contentLocker.upgradeToAccess")}
            style={{
              cursor: "pointer",
              opacity: 0.95,
              filter: isDark ? "brightness(1.4)" : undefined,
            }}
            onClick={openPlanModal}
          />
        </Tooltip>
      </Flex>

      <ChoosePlanModal
        isOpen={showPlanModal}
        onClose={() => closePlanModal()}
        title={t("plans.changePlanAnytime")}
      />
    </>
  );
};
